module.exports = __webpack_public_path__ + "media/images/lb/817-80e7487a73b12b80254b276b9a9aff08.svg";